export const USER = {
  USER: 'user',
  USER_LIST: 'user_list',
  AUTHORS: 'authors',
  USERS_BY_ROLE: 'users_by_role',
};
